import { MapPin, ArrowUpRight } from "lucide-react";
import { AREAS, waLink } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const ServiceArea = () => (
  <section id="locations" data-testid="service-area-section" className="bg-cream py-24 md:py-32">
    <div className="max-w-5xl mx-auto px-5 md:px-10 text-center">
      <SectionHeading chapter="12" eyebrow="Where We Cater" title="Based in Mandvi." script="Serving celebrations across Kutch." align="center" />

      <Reveal className="mt-12">
        <div data-testid="primary-location" className="inline-flex items-center gap-3 bg-espresso text-cream px-8 py-5">
          <MapPin size={20} className="text-gold" />
          <span className="font-serif text-2xl">{AREAS.primary}</span>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="mt-10 flex flex-wrap justify-center gap-3">
        {AREAS.others.map((city) => (
          <a
            key={city}
            data-testid={`area-${city.toLowerCase().replace(/\s+/g, "-")}`}
            href={waLink(`Hi Momay Caterers, I'm planning an event in ${city}. Do you cater there? Let's discuss my requirements.`)}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 border border-espresso/20 px-6 py-3 text-sm text-espresso/70 hover:border-gold hover:text-gold-dark transition-colors duration-300"
          >
            {city}
            <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
          </a>
        ))}
      </Reveal>

      <Reveal delay={0.15}>
        <p className="mt-10 text-espresso/50 text-sm font-light max-w-xl mx-auto">
          Planning an event outside our regular service area? Contact us and let's discuss your requirements.
        </p>
      </Reveal>
    </div>
  </section>
);
